/**
 * Cloud implementation of the shared ModelApi. Node-scoped: binds the selected node id
 * and proxies through the node. Cameras for the attach picker come from getNodeCameras.
 */
import type { ModelApi, Model, CameraRef } from '@trinetra/shared';
import {
  getNodeModels,
  createNodeModel,
  updateNodeModel,
  deleteNodeModel,
  attachModelToCamera,
  getNodeCameras,
  getNodeReportSurfaces,
} from '../services/api.service';
import { selectedNodeId as nodeId } from './node';

function toArray(res: any): any[] {
  return Array.isArray(res) ? res : res?.data || [];
}

export const cloudModelApi: ModelApi = {
  async list(params) {
    const id = nodeId();
    if (!id) return { data: [], meta: null };
    const raw: any = await getNodeModels(id, params || {});
    return {
      data: (Array.isArray(raw) ? raw : raw?.data || []) as Model[],
      meta: raw?.meta || raw?.pagination || null,
    };
  },
  create: (data) => createNodeModel(nodeId() as string, data),
  update: (id, data) => updateNodeModel(nodeId() as string, id, data),
  delete: (id) => deleteNodeModel(nodeId() as string, id),
  attachToCamera: (modelId, cameraId, config) => attachModelToCamera(nodeId() as string, modelId, cameraId, config),
  async listCameras() {
    const id = nodeId();
    if (!id) return [];
    return toArray(await getNodeCameras(id)) as CameraRef[];
  },
  async surfacesWithData() {
    const id = nodeId();
    return id ? getNodeReportSurfaces(id) : [];
  },
};
